var $93ae97679e9e958f$exports = {};
$93ae97679e9e958f$exports = {
    "invalidSelection": (args, formatter)=>`Izabrani ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nije dostupan.`
};


export {$93ae97679e9e958f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
